import React from 'react';
import { Link } from 'react-router-dom';
import './Homework3.css';

const Homework3: React.FC = () => {
  const questions = [
    {
      id: 1,
      title: 'Histogram Stretching',
      description: 'Apply percentile-based histogram stretching to enhance image contrast',
      path: '/homework/3/question1',
      color: '#3b82f6'
    },
    {
      id: 2,
      title: 'Histogram Equalization',
      description: 'Redistribute pixel intensities for uniform histogram distribution',
      path: '/homework/3/question2',
      color: '#10b981'
    },
    {
      id: 3,
      title: 'Custom Transfer Function',
      description: 'Manual contrast control with adjustable black and white levels',
      path: '/homework/3/question3',
      color: '#f59e0b'
    },
    {
      id: 4,
      title: 'Dual Image Comparison',
      description: 'Side-by-side histogram equalization comparison on two images',
      path: '/homework/3/question4',
      color: '#8b5cf6'
    }
  ];

  return (
    <div className="homework3-container">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="content-wrapper">
        <Link to="/" className="back-button">
          ← Back to Hub
        </Link>

        <header className="homework3-header">
          <div className="badge">Homework 3</div>
          <h1>Histogram Operations</h1>
          <p className="subtitle">Advanced Image Enhancement Techniques</p>
        </header>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Histogram Analysis</h3>
            <p>Real-time histogram visualization for all operations</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎨</span>
            <h3>Contrast Enhancement</h3>
            <p>Multiple techniques for improving image visibility</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚙️</span>
            <h3>Manual Implementation</h3>
            <p>All algorithms built from scratch without libraries</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔧</span>
            <h3>Interactive Controls</h3>
            <p>Adjustable parameters with live preview</p>
          </div>
        </div>

        <div className="questions-section">
          <h2>Select a Question</h2>
          <div className="questions-grid">
            {questions.map((question) => (
              <Link
                key={question.id}
                to={question.path}
                className="question-card"
                style={{ '--card-color': question.color } as React.CSSProperties}
              >
                <div className="question-number">Q{question.id}</div>
                <h3>{question.title}</h3>
                <p>{question.description}</p>
                <div className="card-arrow">→</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homework3;
